module.exports = __webpack_public_path__ + "img/image_29.c1e03a2f.png";